<template>
  <div class="padding-10">
    <v-btn tile color="info" @click="refreshPage" style="margin-bottom: 10px;">
  <v-icon left>mdi-refresh</v-icon>
  <slot>
    Clear Form
  </slot>
</v-btn>
    <v-card class="white-background padding-5" :elevation="$root.ele">
      <v-form v-if="!isLoading" v-model="isValid" ref="form">
        <!-- <p v-if="item.uploads">{{ present }}</p> -->
        <job-details
          :imgStatus="isUploadImg"
          :item="item"
          ref="toolbar"
          :isAutoJob="isAutoJob"
          v-model="toolbar"
          @emptyJobDetails="emptyJobDetails"
          :total="total"
        ></job-details>
        <Form
          @onAPTSelected="$refs.toolbar.openAPT()"
          :item="item"
          :toolbar="toolbar"
          :template="template"
          @autoJob="isAutoJob = true"
          v-model="form"
        ></Form>
        <unknown-fields :item="item"></unknown-fields>
        <customer-footer
          v-if="isCustomer"
          @updateCustomer="updateCustomer"
          :item="item"
          @confirmJob="confirmJob"
          @addRecord="addRecord($event)"
        ></customer-footer>
        <job-footer
          v-else
          @onComplete="onComplete"
          @updateCustomer="updateCustomer"
          :item="item"
        ></job-footer>
      </v-form>
    </v-card>
    <complete
      :item="item"
      :form="toolbar"
      :disposition_date="disposition_date"
      v-if="complete"
      @close="complete = false"
    >
    </complete>
  </div>
</template>

<script>
import {
  getDate,
  getDateOnly,
  getNormalDateTime,
} from "../../assets/js/common";
import {
  getCommonField,
  getCreditCardCharges,
  getOptionValue,
} from "../../assets/js/customer.helper";
import customerMixins from "../../assets/js/customer.mixins";
import customerModal from "../../assets/js/customer.modal";
import { auth, customers, functions, estimate } from "../../assets/js/firebase";
import Complete from "../jobs/Complete.vue";
import CustomerFooter from "./create/CustomerFooter.vue";
import Form from "./create/Form.vue";
import JobFooter from "./create/JobFooter.vue";
import JobDetails from "./create/JobDetails.vue";
import UnknownFields from "./create/UnknownFields.vue";
import { EventBus } from "../../main";
export default {
  components: {
    JobDetails,
    Form,
    CustomerFooter,
    JobFooter,
    Complete,
    UnknownFields,
  },
  mixins: [customerMixins],
  data() {
    return {
      isUploadImg : false,
      isValid: false,
      isLoading: true,
      isAutoJob: false,
      item: {},
      form: {},
      complete: false,
      disposition_date: "",
      toolbar: {
        template: "",
        technician: "",
        is_scheduled: false,
        scheduled_at: "",
        disposition: "",
        schedule_end_at: "",
        disposition_date: "",
        dispatcher: "",
        created_at: getDateOnly(),
        status: 0,
        vin_number: "",
        reason: "",
        technician_total_collected: "",
        estimateData: null,         
        isAutofillFromEstimate: false,
        isWaitingForAutofill: false,
      },
      unsubscribe: null,
    };
  },
  computed: {
    total() {
      return this.form[customerModal.TOTAL] || 0;
    },
    template() {
      let template = this.jobTemplates.find((item) => {
        return item.id == this.toolbar.template;
      });
      return template || {};
    },
    isFormFieldChanged() {
      const vm = this;
      let changed = false;
      Object.keys(vm.toolbar).forEach((key) => {
        if (key == "reason") {
          if (
            vm.toolbar[key] !=
            vm.item.fields[customerModal.REASON_FOR_CANCELLATION]
          ) {
            console.log(key);
            changed = true;
          }
        } else if (vm.toolbar[key] != vm.item[key]) {
          console.log(key);
          changed = true;
        }
      });
      Object.keys(vm.item.fields).forEach((key) => {
        let excludeKeys = ["Phone", customerModal.REASON_FOR_CANCELLATION];
        if (
          vm.form[key] != vm.item.fields[key] &&
          excludeKeys.indexOf(key) == -1
        ) {
          console.log(vm.form[key], vm.item.fields[key]);
          changed = true;
        }
      });
      return changed;
    },
    isETA() {
      let ETA = this.form[customerModal.ETA];
      let isETA = true;
      if (ETA) {
        isETA = ETA.toString().toLowerCase() == "appointment";
      }
      return isETA;
    },
    isAppointment() {
      const vm = this;
      let isAppointment = false;
      let { is_scheduled, scheduled_at } = vm.toolbar;
      let eta = vm.form[customerModal.ETA];
      if (eta) {
        isAppointment = eta.toString().toLowerCase() == "appointment";
      }
      return isAppointment && (is_scheduled != true || scheduled_at == "");
    },
    isTechnicianChanged() {
      const vm = this;
      if (!vm.isJob) return false;
      let { technician, status } = vm.getDoc();
      let statusList = [1, 2];
      return (
        statusList.indexOf(status) != -1 && technician != vm.item.technician
      );
    },
    isComingFromEstimate() {
      return this.$route.query.autofill === 'true' && this.$route.query.estimateId;
    }
  },
  beforeDestroy() {
    const vm = this;
    vm.$root.loading = false;
    if (vm.unsubscribe != null) vm.unsubscribe();
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    'toolbar.template'(newTemplate , oldTemplate  ) {
      if (this.isComingFromEstimate && newTemplate && this.estimateData) {
        setTimeout(() => {
          this.applyEstimateAutofill();
        }, 500);
      }
    },
    // eslint-disable-next-line no-unused-vars
    'form'(newForm, oldForm) {
      if (this.isWaitingForAutofill && Object.keys(newForm).length > 0) {
        // console.log('Form fields loaded, applying estimate autofill...');
        this.isWaitingForAutofill = false;
        // Use nextTick to ensure DOM is updated
        this.$nextTick(() => {
          this.applyEstimateAutofill();
        });
      }
    }
  },
  methods: {
    async loadEstimateForAutofill() {
      try {
        const estimateId = this.$route.query.estimateId;
        if (!estimateId) return;

        // console.log('Loading estimate for autofill:', estimateId);
        this.$root.loader = true;

        const estimateDoc = await estimate.doc(estimateId).get();
        
        if (estimateDoc.exists) {
          this.estimateData = estimateDoc.data();
          // console.log('Estimate data loaded:', this.estimateData);

           // Set template if it exists in estimate
           if (this.estimateData.template) {
            this.toolbar.template = this.estimateData.template;
            this.isWaitingForAutofill = true; // Flag to apply autofill after form loads
          }
        }
        
        this.$root.loader = false;
      } catch (error) {
        console.error('Error loading estimate:', error);
        this.$root.loader = false;
      }
    },
    applyEstimateAutofill() {
      if (!this.estimateData) return;
      
      // console.log('Applying estimate autofill...');
      
      // Apply estimate field values with highest priority
      if (this.estimateData.fields) {
        Object.keys(this.estimateData.fields).forEach(fieldId => {
          const estimateValue = this.estimateData.fields[fieldId];
          if (estimateValue !== undefined && estimateValue !== null && estimateValue !== '') {
            // ✅ Override existing form values with estimate data
            this.$set(this.form, fieldId, estimateValue);
            // }
            // console.log(`Autofilled field ${fieldId}:`, estimateValue);
          }
        });
        // console.log('/form ', this.form)
      }

      // Also autofill toolbar values if they exist in estimate
      if (this.estimateData.technician) {
        this.toolbar.technician = this.estimateData.technician;
      }
      if (this.estimateData.is_scheduled) {
        this.toolbar.is_scheduled = this.estimateData.is_scheduled;
        this.toolbar.scheduled_at = this.estimateData.scheduled_at;
        this.toolbar.schedule_end_at = this.estimateData.schedule_end_at;
      }

      // if (this.$refs.form && this.$refs.form.input) {
      //   this.$refs.form.input();  // Triggers Form.vue's input method to sync everything
      // }
    },
    getCountryCode(){
      return this.countryCode;
    },
    
    clearJobDetails() {
      this.emptyJobDetails();
    },
    onComplete(date) {
      this.complete = true;
      console.log("disposition_date", date);
      this.disposition_date = date;
    },
    async addRecord(isSendSMS) {
      const vm = this;
      vm.$refs.form.validate();
      if (!vm.isValid) return;

      let doc = vm.getDoc();
      if (vm.isAppointment) {
        vm.$alert.show("Please provide the appointment date and time.");
        return;
      }
      vm.$confirm.show({
        message: "Are you sure, Do you want to do this action?",
        onConfirm: async () => {
          let call = functions.httpsCallable("createCustomer");
          try {
            vm.$loader.show();
            let { data } = await call({ data: doc, isSendSMS });
            // !!!Only for developers
            // let i=1;
            // while(i<=10){
            //   let { data } = await call({ data: doc, isSendSMS });
            //   console.log('cycle: ', i, "data: ", data)
            //   i++
            // }
            vm.$loader.hide();
            if (data.status === true) {
              vm.$router.replace("/");
            } else {
              vm.$alert.show(data.message);
            }
          } catch (error) {
            vm.$loader.hide();
            vm.$alert.show(error.message);
          }
        },
      });
    },
    async confirmJob() {
      const vm = this;
      if (vm.isFormFieldChanged) {
        return vm.$alert.show("Please save the changes");
      }
      vm.$refs.form.validate();
      if (!vm.isValid) return;
      try {
        vm.$root.loader = true;
        let updated_at = getDate();
        await functions.httpsCallable("jobConfirm")({
          id: vm.customerId,
          updated_at,
          is_self: true,
        });
        vm.$root.loader = false;
      } catch (e) {
        vm.loading = false;
        vm.$root.loader = false;
        vm.$alert.show(e.message);
      }
    },
    async resend() {
      const vm = this;
      try {
        vm.$loader.show();
        let { data } = await functions.httpsCallable("resendSMS")({
          id: vm.customerId,
          updated_at: getDate(),
        });
        vm.$loader.hide();
        if (data.status) {
          vm.$alert.show(data.message);
        } else {
          vm.$alert.show("SMS has been submitted to successfully");
        }
      } catch (error) {
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
    async updateCustomer() {
      const vm = this;
      let { isTechnicianChanged } = vm;
      vm.$refs.form.validate();
      if (!vm.isValid) return;
      
      if (!vm.isUploadImg && !vm.isFormFieldChanged) {
        return vm.$alert.show("There is nothing to update");
      }
      if (vm.isAppointment) {
        vm.$alert.show("Please provide the appointment date and time.");
        return;
      }
      try {
        vm.$loader.show();
        let doc = vm.getDoc();
        let isScheduleChanged = doc.scheduled_at != vm.item.scheduled_at;
       doc.uploads = vm.item.uploads;
       if(!doc.uploads){
          doc.uploads = [];
        }
        // let 
        await customers.doc(vm.customerId).update(doc);
        if (isScheduleChanged) {
          await functions.httpsCallable("reScheduleSMS")({
            scheduled_at: doc.scheduled_at,
            id: vm.customerId,
          });
        }
        if (isTechnicianChanged) {
          console.log("Technician is changed");
          await functions.httpsCallable("assignTechnician")({
            technician: doc.technician,
            id: vm.item.id,
            updated_at: doc.updated_at,
          });
        } else {
          console.log("Technician not changed");
        }

        vm.$loader.hide();
        vm.$confirm.show({
          message:
            "You have made the changes.<br/> Do you want to Resend the SMS to this customer?",
          noText: "No, Close",
          yesText: "Yes, Send Text",
          onConfirm: async () => {
            vm.resend();
            await customers.doc(vm.customerId).update({ is_agree: false });
          },
        });
      } catch (error) {
        vm.$alert.show(error.message);
        vm.$loader.hide();
      }
    },
    init() {
      const vm = this;
      let { params } = vm.$route;
      if (vm.isCreate) {
        if (this.isComingFromEstimate) {
          //this form goes into the grtDoc() which is used to create the customer
          vm.loadEstimateForAutofill();

          // this data is used to populate the form and toolbar via this.item

          try {
            // await estimate.doc(estimateId).get()
            const estimateId = this.isComingFromEstimate;
            if (!estimateId) return;
            vm.unsubscribe = estimate.doc(estimateId).onSnapshot(
              (snap) => {
                vm.$root.loader = false;
                if (snap.exists) {
                  vm.isLoading = true;
                  let doc = snap.data();
                  // doc.id = snap.id;
                  vm.item = doc;
                  console.log('api fetcing', doc);
                  Object.keys(vm.toolbar).forEach((key) => {
                    if(key != 'created_at'){
                      let val = doc[key];
                      if (val != undefined) vm.toolbar[key] = val;
                    }
                  });
                  vm.toolbar.reason =
                    doc.fields[customerModal.REASON_FOR_CANCELLATION] || "";
                  vm.isLoading = false;
                } else {
                  vm.$root.alert("Customer not found");
                  vm.$router.replace("/");
                }
              },
              (error) => {
                vm.$root.loader = false;
                vm.$root.alert(error.message);
              }
            );
          } catch (error) {
            vm.$root.loader = false;
            vm.$root.alert(error.message);
          }
        }
          vm.isLoading = false;
        return;
      }
      let { id } = params;
      vm.$root.loader = true;
      try {
        vm.unsubscribe = customers.doc(id).onSnapshot(
          (snap) => {
            vm.$root.loader = false;
            if (snap.exists) {
              vm.isLoading = true;
              let doc = snap.data();
              doc.id = snap.id;
              vm.item = doc;
              Object.keys(vm.toolbar).forEach((key) => {
                let val = doc[key];
                if (val != undefined) vm.toolbar[key] = val;
              });
              vm.toolbar.reason =
                doc.fields[customerModal.REASON_FOR_CANCELLATION] || "";
              vm.isLoading = false;
            } else {
              vm.$root.alert("Customer not found");
              vm.$router.replace("/");
            }
          },
          (error) => {
            vm.$root.loader = false;
            vm.$root.alert(error.message);
          }
        );
      } catch (error) {
        vm.$root.loader = false;
        vm.$root.alert(error.message);
      }
    },
    getDoc() {
      const vm = this;
      let { form, toolbar, template, item } = vm;
      let { phone, name } = getCommonField(form);
      let email = auth.currentUser.email;
      let doc = {};
      Object.keys(toolbar).forEach((key) => {
        doc[key] = toolbar[key];
      });
      delete doc.reason;
      doc.fields = form;
      doc.fields[customerModal.REASON_FOR_CANCELLATION] = toolbar.reason || "";
      doc.options = getOptionValue(vm, vm.form);
      doc.updated_by = email;
      doc.name = name;
      doc.name_lower = name.toLowerCase();
      doc.charges = getCreditCardCharges(vm.form, vm);
      doc.created_at = getNormalDateTime(doc.created_at);
      if (doc.disposition_date) {
        doc.disposition_date = getNormalDateTime(doc.disposition_date);
      }
      doc.fields.Phone = phone;
      doc.updated_at = getDate();
      if (vm.isCreate) {
        doc.sms = "i";
        doc.template_name = template.name;
        doc.message = template.message;
        doc.reimbusements = 0;
        doc.is_agree = false;
        if (this.isETA) doc.status = 4;
      } else {
        if (item.status == 1 && doc.technician) {
          doc.status = 2;
        }
        if (item.status == 5 && doc.technician) {
          doc.status = 6;
        }
        if (item.template != template.id) {
          doc.template_name = template.name;
          doc.message = template.message;
        }
        if (item.status == 7 && doc.status != 7) {
          doc.disposition = "";
          doc.disposition_date = "";
        }
      }
      Object.keys(doc).forEach((key) => {
        if (doc[key] == undefined) {
          doc[key] = "";
        }
      });
      return doc;
    },
    refreshPage() {
      EventBus.$emit("emptyJobDetails")
      this.emptyJobDetails();
    }, 
    emptyJobDetails() {
      this.isValid = false;
      this.isAutoJob = false;
      this.item = {};
      this.form = {};
      this.complete = false;
      this.toolbar = {
        template: "",
        technician: "",
        is_scheduled: false,
        scheduled_at: "",
        disposition: "",
        schedule_end_at: "",
        disposition_date: "",
        dispatcher: "",
        created_at: getDateOnly(),
        status: 0,
        vin_number: "",
        reason: "",
        technician_total_collected: "",      
      };
      this.unsubscribe = false
    },

    changeImgStatus() {
      this.isUploadImg = true;
    },
    changeCashStatus() {
      this.isFormFieldChanged = true;
    },

    setUploadsData(data) {
      this.item.uploads = data;
      //console.log('upload data are set ', data);
    }
  },
  mounted() {
    this.init();
    EventBus.$on("changeImgStatus",this.changeImgStatus);
    EventBus.$on("changeCashStatus", this.changeCashStatus);
    EventBus.$on("getFiles",this.setUploadsData)
  },
};
</script>

<style></style>
